import { TopEpisode } from '../../types';

export function rankAndSortEpisodesByShow(episodesByShow: TopEpisode[][]) {
  let allEpisodes: TopEpisode[] = [];

  for (let episodes of episodesByShow) {
    allEpisodes.push(...episodes);
  }

  return allEpisodes.sort(sortRankedEpisodesDescending);
}

function sortRankedEpisodesDescending(a: TopEpisode, b: TopEpisode) {
  return b.starts - a.starts;
}
